// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__STkTE","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__4yJGK"};